<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>

    <ModalsController />
  </v-app>
</template>

<script setup>
const router = useRouter()

onMounted(() => {
  if (
    !window.tokenParsed.realm_access.roles.includes(
      'DAAI_HEALTHCARE_PROFESSIONAL_ROLE',
    )
  ) {
    router.push('/payment-wall')
  }
})
</script>

<style lang="scss">
$toast-replaces: (
  'success': rgba(var(--v-theme-success-darken-1)),
  'error': rgba(var(--v-theme-error)),
  'warning': rgba(var(--v-theme-warning-darken-1)),
  'info': rgba(var(--v-theme-info-darken-1)),
);

@each $type, $color in $toast-replaces {
  .Vue-Toastification__toast--#{$type} {
    background-color: $color;
    font-weight: 600;
  }
}
</style>
